import { createRequestTypes } from '../utils';

export const FUNCTION_LIST = createRequestTypes('function/FUNCTION_LIST');
